import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const HistoricalPage = withSuspense(
	lazy(async () => await import('./historical-page.component')),
	PageLoader,
);
